import React from 'react';

import {
  XingFrameProvider,
  LOGIN_STATE,
} from '@xingternal/xing-frame-provider';
import navigationData from '@xingternal/xing-frame-provider/data/navigation'; // eslint-disable-line
import withApolloData from '@xingternal/xing-frame-provider/withApolloData'; // eslint-disable-line
import withStaticData from '@xingternal/xing-frame-provider/withStaticData'; // eslint-disable-line
import GlobalStyles from '@xingternal/global-styles';
import { useServerData } from '@xingternal/hops';
import { ErrorContainer } from '@xingternal/pages-page-error';

import ScrollToTop from './components/ScrollToTop';
import Routes from './Routes';
import MODULES from './modulesMap';

import {
  EditContextProvider,
  PageContextProvider,
  URL_SOCIAL_BAR,
} from '@xingternal/pages-common';
import { useWineryTagManager } from './hooks/use-winery-tag-manager/use-winery-tag-manager';

const FrameProvider = (props: {
  internalPaths?: string[];
  children: React.ReactNode;
}) => {
  const { loginState } = useServerData();
  useWineryTagManager();

  const Component =
    loginState !== LOGIN_STATE.loggedOut
      ? withApolloData(XingFrameProvider)
      : withStaticData({ navigationData })(XingFrameProvider);

  return <Component {...props} loginState={loginState} />;
};

// Checks if a module has a subpage and builds the url for internal path
const subpagePaths = Object.keys(MODULES)
  .filter((module) => !!MODULES[module].subpageModule)
  .map((module) => `/[^/]+/${module}`);

const App = (
  <ErrorContainer>
    <FrameProvider
      internalPaths={[
        ...subpagePaths,
        '/pages/new/company',
        '/pages/[^/]+',
        '/[^/]+/demo',
        `${URL_SOCIAL_BAR}/[^/]+`,
        '/[^/]+/edit/[^/]+',
      ]}
    >
      <EditContextProvider>
        <PageContextProvider>
          <GlobalStyles>
            <ScrollToTop />
            <Routes />
          </GlobalStyles>
        </PageContextProvider>
      </EditContextProvider>
    </FrameProvider>
  </ErrorContainer>
);

export default App;
